import { render, staticRenderFns } from "./pricingBlock.vue?vue&type=template&id=0fc7a69e&scoped=true"
import script from "./pricingBlock.vue?vue&type=script&lang=js"
export * from "./pricingBlock.vue?vue&type=script&lang=js"
import style0 from "./pricingBlock.vue?vue&type=style&index=0&id=0fc7a69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc7a69e",
  null
  
)

export default component.exports